import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { Sizes, themeColor } from '../../components/Theme';
import { dict } from '../../constants/system_reference';
import { media } from '../media';
import { getTimeLeft, parseTimeLeft } from '../../components/Stages/timeHelpers';



export const QuestionDeadline = ({ date }: { date: string }) => {
    const [timeLeft, setTimeLeft] = useState(getTimeLeft(date));

    useEffect(() => {
        const interval = setInterval(() =>
            setTimeLeft(getTimeLeft(date))
            , 60000);
        return () => clearInterval(interval);
    }, [setTimeLeft, date]);

    const timeLeftX = useMemo(
      () => parseTimeLeft(timeLeft),
      [timeLeft]);

    return timeLeft.asMilliseconds() > 0 ? <Wrapper>
        <Warning><FormattedMessage id="service.leftToEnd" /></Warning>
        <EndTime>
            {
                date === null
                    ? <FormattedMessage id="addition.unknown" />
                    : <>
                        <Time>{timeLeftX.formatted.days[0]}</Time>
                        <Time>{timeLeftX.formatted.days[1]}</Time>
                        <Type><FormattedMessage id="service.d" /></Type>

                        <Time>{timeLeftX.formatted.hours[0]}</Time>
                        <Time>{timeLeftX.formatted.hours[1]}</Time>
                        <Type><FormattedMessage id="service.hr" /></Type>

                        <Time>{timeLeftX.formatted.minutes[0]}</Time>
                        <Time>{timeLeftX.formatted.minutes[1]}</Time>
                        <Type><FormattedMessage id="service.mn" /></Type>
                    </>
            }

        </EndTime>
    </Wrapper>
    :
    <></>;
}

const Wrapper = styled.div`
    padding: 20px 25px;
    width: 289px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 30px auto 50px auto;

    border-radius: ${Sizes.geometry.borderRadius.pannel}px;
    background: ${themeColor(c => c.question_case.descriptionBackground)};
    box-shadow: ${dict.spl.boxShadow.average} inset ${themeColor(c => c.blackShadow)};

    @media ${media.m} {
        padding: 30px 0;
        width: 70%;
    }
`;

const Type = styled.p`
    margin: 0 10px 0 7px;
    font: 300 20px "Ubuntu";
    color: ${themeColor(c => c.blackDefault)};
`;

const Warning = styled.div`
    margin-bottom: 10px;
    text-align: center;
    font: 300 20px "Ubuntu";
    color: ${themeColor(c => c.textGreyBasic)};
`;

const EndTime = styled.div`
    padding: 0.2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${media.m} {
        width: fit-content;
        margin: auto;
    }

    @media ${media.xs} {
        display: grid;
        grid-template-columns: repeat(3, auto);
    }
`;

const Time = styled.p`
    margin: 0 0.3rem;
    font: 500 20px "Ubuntu";
    color: ${themeColor(c => c.blackDefault)};
    background-color: ${themeColor(c => c.whiteDefault)};
`;
